import script from "./ConversationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationView.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationView.vue?vue&type=style&index=0&id=1930fba4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1930fba4"]])

export default __exports__